module.exports = __webpack_public_path__ + "img/logo.e3393bb1.png";